// src/data/medalsDefinitions.js
import { CONDITION_TYPES } from '../utils/conditionTypes';

export const ALL_DEFINITIONS = [
  // ===== مدال‌های ریاضی =====
  {
    id: 'math_genius',
    name: 'نابغه اعداد',
    icon: '🧮',
    category: 'ریاضی',
    description: '۱۰۰ مسئله ریاضی را حل کن',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'solve_problem',
      filter: { subject: 'math' },
      target: 100,
    }
  },
  {
    id: 'math_collector',
    name: 'جمع‌باز',
    icon: '➕',
    category: 'ریاضی',
    description: '۵۰ جمع صحیح انجام بده',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'solve_problem',
      filter: { subject: 'math', operation: 'addition' },
      target: 50,
    }
  },
  {
    id: 'math_multiplier',
    name: 'ضرب‌دان',
    icon: '✖️',
    category: 'ریاضی',
    description: '۳۰ ضرب پیچیده را حل کن',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'solve_problem',
      filter: { subject: 'math', operation: 'multiplication' },
      target: 30,
    }
  },
  {
    id: 'geometry_master',
    name: 'هندسه‌کار',
    icon: '📐',
    category: 'ریاضی',
    description: '۲۰ مسئله هندسه حل کن',
    type: 'medal',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'solve_problem',
      filter: { subject: 'geometry' },
      target: 20,
    }
  },

  // ===== مدال‌های علوم =====
  {
    id: 'little_explorer',
    name: 'کاشف کوچک',
    icon: '🔬',
    category: 'علوم',
    description: '۵۰ آزمایش علمی انجام بده',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'science_experiment',
      target: 50,
    }
  },
  {
    id: 'biologist',
    name: 'زیست‌شناس',
    icon: '🧬',
    category: 'علوم',
    description: '۳۰ سلول را تشخیص بده',
    type: 'medal',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'science_experiment',
      filter: { type: 'biology' },
      target: 30,
    }
  },
  {
    id: 'chemist',
    name: 'شیمیدان',
    icon: '⚗️',
    category: 'علوم',
    description: '۲۰ ترکیب شیمیایی بساز',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'science_experiment',
      filter: { type: 'chemistry' },
      target: 20,
    }
  },
  {
    id: 'astronomer',
    name: 'ستاره شناس',
    icon: '🔭',
    category: 'علوم',
    description: '۱۰ کهکشان را شناسایی کن',
    type: 'medal',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'science_experiment',
      filter: { type: 'astronomy' },
      target: 10,
    }
  },

  // ===== مدال‌های هنر =====
  {
    id: 'bookworm',
    name: 'کتاب‌خوان',
    icon: '📚',
    category: 'هنر',
    description: '۱۰ کتاب کامل بخوان',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'read_book',
      target: 10,
    }
  },
  {
    id: 'poet',
    name: 'شاعر',
    icon: '✍️',
    category: 'هنر',
    description: '۵ شعر قشنگ بسرا',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'poem_written',
      target: 5,
    }
  },
  {
    id: 'artist',
    name: 'هنرمند',
    icon: '🎨',
    category: 'هنر',
    description: '۱۰ نقاشی زیبا بکش',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'drawing_made',
      target: 10,
    }
  },

  // ===== مدال‌های جغرافیا =====
  {
    id: 'world_explorer',
    name: 'جهان‌نورد',
    icon: '🌍',
    category: 'جغرافیا',
    description: '۲۰ کشور را روی نقشه پیدا کن',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'country_found',
      target: 20,
    }
  },
  {
    id: 'flag_master',
    name: 'پرچم‌دان',
    icon: '🏳️',
    category: 'جغرافیا',
    description: '۱۵ پرچم کشورها را حفظ کن',
    type: 'medal',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'flag_learned',
      target: 15,
    }
  },

  // ===== مدال‌های ورزش =====
  {
    id: 'football_star',
    name: 'فوتبالیست',
    icon: '⚽',
    category: 'ورزش',
    description: '۲۰ گل بزن',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'football_goal',
      target: 20,
    }
  },
  {
    id: 'runner',
    name: 'دونده',
    icon: '🏃',
    category: 'ورزش',
    description: '۱۰۰ کیلومتر بدو',
    type: 'medal',
    rare: false,
    condition: {
      type: CONDITION_TYPES.SUM,
      event: 'running_distance',
      metric: 'distance',
      target: 100, // کیلومتر
    }
  },
  {
    id: 'swimmer',
    name: 'شناگر',
    icon: '🏊',
    category: 'ورزش',
    description: '۵۰ متر شنا کن',
    type: 'medal',
    rare: true,
    condition: {
      type: CONDITION_TYPES.SUM,
      event: 'swimming_distance',
      metric: 'distance',
      target: 50, // متر
    }
  },

  // ===== دستاوردهای روال =====
  {
    id: 'early_bird',
    name: 'سحرخیز',
    icon: '🌅',
    category: 'روال',
    description: '۵۰ روز قبل از ساعت ۸ صبح مطالعه کن',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.STREAK,
      event: 'study_session',
      timeRange: { start: '05:00', end: '07:59' },
      target: 50,
    }
  },
  {
    id: 'night_owl',
    name: 'شب‌زنده‌دار',
    icon: '🦉',
    category: 'روال',
    description: '۳۰ شب تا نیمه‌شب مطالعه کن',
    type: 'achievement',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'study_session',
      timeRange: { start: '22:00', end: '23:59' },
      target: 30,
    }
  },
  {
    id: 'organized',
    name: 'منظم',
    icon: '📋',
    category: 'روال',
    description: '۳۰ روز برنامه‌ریزی روزانه داشته باش',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'daily_plan',
      target: 30,
    }
  },
  {
    id: 'persistent',
    name: 'پشتکار',
    icon: '💪',
    category: 'روال',
    description: '۲۰ روز بدون وقفه درس بخوان',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.STREAK,
      event: 'study_session',
      target: 20,
    }
  },

  // ===== دستاوردهای اجتماعی =====
  {
    id: 'helper',
    name: 'همیار',
    icon: '🤝',
    category: 'اجتماعی',
    description: 'به ۱۰ نفر از دوست‌هایت کمک کن',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'helped_friend',
      target: 10,
    }
  },
  {
    id: 'team_leader',
    name: 'رهبر تیم',
    icon: '👥',
    category: 'اجتماعی',
    description: '۵ بار تیم را رهبری کن',
    type: 'achievement',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'team_lead',
      target: 5,
    }
  },

  // ===== دستاوردهای سلامت =====
  {
    id: 'health_focused',
    name: 'سلامت‌محور',
    icon: '🧘',
    category: 'سلامت',
    description: '۳۰ روز ورزش روزانه انجام بده',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'daily_exercise',
      target: 30,
    }
  },
  {
    id: 'healthy_eating',
    name: 'تغذیه سالم',
    icon: '🥗',
    category: 'سلامت',
    description: '۲۰ روز غذای سالم بخور',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'healthy_meal',
      target: 20,
    }
  },

  // ===== دستاوردهای خلاقیت =====
  {
    id: 'creative',
    name: 'خلاق',
    icon: '🎭',
    category: 'خلاقیت',
    description: '۵ ایده جدید و جالب بیاور',
    type: 'achievement',
    rare: false,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'new_idea',
      target: 5,
    }
  },
  {
    id: 'innovator',
    name: 'نوآور',
    icon: '💡',
    category: 'خلاقیت',
    description: '۳ پروژه خلاقانه انجام بده',
    type: 'achievement',
    rare: true,
    condition: {
      type: CONDITION_TYPES.COUNT,
      event: 'creative_project',
      target: 3,
    }
  },
];